import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import React, { useContext } from 'react';

import { AttributeDefinitionsContext } from '../../AttributeDefinitionsContext';

function IncludeInSearchKeywordsFilter() {
  const { includeInSearchKeywords, setIncludeInSearchKeywords } = useContext(AttributeDefinitionsContext);

  const handleChange = (e) => {
    const val = e.target.value === 'All' ? null : e.target.value;
    setIncludeInSearchKeywords(val);
  };

  return (
    <FormControl fullWidth className="min-w-[140px]">
      <InputLabel id="includeInSearchKeywords">IncludeInSearchKeywords</InputLabel>
      <Select
        labelId="includeInSearchKeywords"
        label="IncludeInSearchKeywords"
        value={includeInSearchKeywords === null ? 'All' : includeInSearchKeywords}
        onChange={handleChange}
      >
        <MenuItem value="All">All</MenuItem>
        <MenuItem value>Yes</MenuItem>
        <MenuItem value={false}>No</MenuItem>
      </Select>
    </FormControl>
  );
}

export default IncludeInSearchKeywordsFilter;
